<section class="bg-gradient-to-b from-white to-gray-50 py-16 px-10 text-center">
  <h2 class="text-primary font-bold text-3xl md:text-5xl mb-4 animate-fadeInUp">
    Suscribirte es <span class="text-secondary">muy fácil</span>
  </h2>
  <p
    class="text-gray text-lg mb-12 animate-fadeInUp"
    style="animation-delay: 0.1s"
  >
    Solo 4 simples pasos te separan del agua purificada
  </p>

  <div
    class="flex flex-col md:flex-row justify-center items-stretch md:gap-8 px-5 md:px-20 max-w-6xl mx-auto"
  >
    <div
      class="md:mb-4 text-center flex-1 p-6 bg-white rounded-2xl shadow-soft hover-lift mb-6 md:mb-0 animate-scaleIn"
      style="animation-delay: 0.2s"
    >
      <div class="mb-4 flex justify-center">
        <img
          src="assets/step1.png"
          class="h-32 md:h-40 object-contain"
          alt=""
        />
      </div>
      <div>
        <h3 class="text-2xl text-primary font-bold mb-2">Elegí</h3>
        <p class="text-gray-700">Elegí el equipo para tu hogar</p>
      </div>
    </div>

    <div
      class="md:mb-4 text-center flex-1 p-6 bg-white rounded-2xl shadow-soft hover-lift mb-6 md:mb-0 animate-scaleIn"
      style="animation-delay: 0.3s"
    >
      <div class="mb-4 flex justify-center">
        <img
          src="assets/step2.png"
          class="h-32 md:h-40 object-contain"
          alt=""
        />
      </div>
      <div>
        <h3 class="text-2xl text-primary font-bold mb-2">Contratá</h3>
        <p class="text-gray-700">Completá tus datos</p>
      </div>
    </div>

    <div
      class="md:mb-4 text-center flex-1 p-6 bg-white rounded-2xl shadow-soft hover-lift mb-6 md:mb-0 animate-scaleIn"
      style="animation-delay: 0.4s"
    >
      <div class="mb-4 flex justify-center">
        <img
          src="assets/step3.png"
          class="h-32 md:h-40 object-contain"
          alt=""
        />
      </div>
      <div>
        <h3 class="text-2xl text-primary font-bold mb-2">Agendá</h3>
        <p class="text-gray-700">Coordiná la instalación</p>
      </div>
    </div>

    <div
      class="md:mb-4 text-center flex-1 p-6 bg-white rounded-2xl shadow-soft hover-lift mb-6 md:mb-0 animate-scaleIn"
      style="animation-delay: 0.5s"
    >
      <div class="mb-4 flex justify-center">
        <img
          src="assets/step4.png"
          class="h-32 md:h-40 object-contain"
          alt=""
        />
      </div>
      <div>
        <h3 class="text-2xl text-primary font-bold mb-2">Disfrutá</h3>
        <p class="text-gray-700">Agua purificada al instante</p>
      </div>
    </div>
  </div>

  <a
    routerLink="/subscription-month"
    class="bg-primary font-bold rounded-full px-12 py-3 text-white inline-flex items-center justify-center mt-12 hover:bg-secondary transition-all ease-in-out shadow-medium hover:shadow-strong hover:scale-105 animate-fadeInUp"
    style="animation-delay: 0.6s"
    >Suscribite ahora
    <svg
      class="ml-2 w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 7l5 5m0 0l-5 5m5-5H6"
      />
    </svg>
  </a>
</section>
